export default __webpack_public_path__ + "static/media/banner_post_page1.d420833b.png";